import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { View } from 'react-native';
import {
  DETAILS_SCREENS_CONTAINER_STYLES,
  SCREEN_PADDING_HORIZONTAL,
} from '../../../../common/constants/base.constants';
import { fullWidth, width } from '@components/frame';
import { isWeb } from '@helpers';
import BatchTimeLine from '@v2/pages/batch/details/modules/batch/components/BatchTimeline/BatchTimeline';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';

interface NCFileDetailsBatchTimelineProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const NCFileDetailsBatchTimelineComponent: FC<NCFileDetailsBatchTimelineProps> = ({
  getProductionBatchByNCFile,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  batch,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.batch}>
      <View
        style={{
          ...DETAILS_SCREENS_CONTAINER_STYLES,
          marginInline: 'auto',
          width: '100%',
        }}
      >
        <BatchTimeLine
          productionBatchId={batch?.data?.productionBatchId ?? undefined}
          width={isWeb ? fullWidth : width}
          withoutList
          horizontalOffset={SCREEN_PADDING_HORIZONTAL * 2}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const NCFileDetailsBatchTimeline = connect(({ batch: { batch } }) => ({ batch }), {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsBatchTimelineComponent);

export { NCFileDetailsBatchTimeline };
